import { FadeIn } from './AnimateIn'
import HeroShade, { HeroImage } from './HeroShade'
import Section from './Section'
import { Text } from './Text'

interface Props {
  title: string
  subtitle?: string
  className?: string
  children: React.ReactNode | React.ReactElement
  button?: React.ReactNode
  image?: HeroImage
}

export default function Hero({ title, className, children, subtitle, button, image }: Props) {
  const parts = title.split(' ')
  return (
    <div
      className={`relative flex flex-col w-full h-screen min-h-[768px] max-h-[768px] lg:max-h-[1024px] ${className ?? ''}`}
    >
      {image && <HeroShade image={image} />}
      <Section
        withVerticalPadding
        topSection
        className='z-10 flex flex-col flex-1 justify-end lg:justify-center pb-[136px]'
      >
        <div className='flex flex-col w-full items-start gap-[72px]'>
          <div className='flex flex-col items-start gap-[32px]'>
            <FadeIn className='flex flex-col gap-[1px] md:gap-[16px]'>
              <Text.H1 className='inline' underline='off'>
                {parts.slice(0, -1).join(' ') + ' '}
                <Text.Gradient className='inline'>{parts.slice(-1)[0]}</Text.Gradient>
              </Text.H1>
              {subtitle ? <Text.H3>{subtitle}</Text.H3> : null}
            </FadeIn>
            <FadeIn delay={0.1} className='max-w-[768px]'>
              {children}
            </FadeIn>
          </div>
          {button ? (
            <FadeIn delay={0.2} className='flex items-start gap-6'>
              {button}
            </FadeIn>
          ) : null}
        </div>
      </Section>
    </div>
  )
}
